import type { RecentTournament } from '@ps/web-shared-api-types/v0/SwHomeGames';

export const getInitialState = () => ({
  available: [] as RecentTournament[],
  recent: [] as RecentTournament[]
});

export const filterTournaments = (tourns: RecentTournament[] | undefined) => {
  if (!tourns || !tourns.length) return getInitialState();

  return tourns.reduce((acc, tourn) => {
    if (!tourn || !tourn.dynamicData) {
      return acc;
    }

    const { status } = tourn.dynamicData;

    if (
      status === 'MT_STATUS_PUBLISHED' ||
      status === 'MT_STATUS_SEATS_AVAIL' ||
      status === 'MT_STATUS_TOURN_STARTED'
    ) {
      acc.available.push(tourn);
    } else {
      acc.recent.push(tourn);
    }

    return acc;
  }, getInitialState());
};
